import React from 'react';
import style from './uiOverlay.css';

import Header from '../../components/playerHeader/playerHeader';
import StartOverlay from '../../containers/StartOverlay';
import Modal from '../../components/modals/modalHolder';
import PlayerControls from '../../containers/PlayerControls';
import TrackSelectorButton from '../../containers/TrackSelectorButton';

const getOverlayBackground = (showModal, hideElements) => {
  if (showModal === 'SharingControl' && hideElements.includes('exitScreen')) {
    return null;
  }

  const backgroundCss = [style.overlay];
  if (showModal && showModal !== 'panel') {
    backgroundCss.push(style.overlayModal);
  }
  return backgroundCss.join(' ');
};

const getHeaderStyle = reverseHeaderLayout => {
  const headerStyle = [style.playerHeader];
  if (reverseHeaderLayout) headerStyle.push(style.reverseHeaderLayout);
  return headerStyle.join(' ');
};

function OverlayControls(props) {
  // Don't show Stats and Buttons during a Modal or while the MiniUI is active
  return props.showingModal || props.miniUi ? null : (
    <div className={style.headerControls}>
      <TrackSelectorButton />
      <div id='StatsPanelContainer' />
    </div>
  );
}

export default function OverlayContainer(props) {
  const showOverlay = props.playerPlaying;
  return props.hideUi ? null : (
    <div className={getOverlayBackground(props.modal.modalType, props.hideElements)}>
      <div className={getHeaderStyle(props.reverseHeaderLayout)}>
        <Header />
        <OverlayControls miniUi={props.miniUi} showingModal={props.modal.modalType} />
      </div>
      <StartOverlay />
      {showOverlay && <Modal modal={props.modal} hideElements={props.hideElements} />}
      {showOverlay && <PlayerControls rootElement={props.rootElement} />}
    </div>
  );
}
